import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useNotificationsStore = defineStore('notifications', () => {
  const localStoreOverride = localStorage.getItem('perClassScheduleConfigVisible') === 'true'
  const perClassScheduleConfigVisible = ref(localStoreOverride)

  const setPerClassScheduleConfigVisible = (value: boolean) => {
    perClassScheduleConfigVisible.value = value
    localStorage.setItem('perClassScheduleConfigVisible', `${value}`)
  }

  return {
    perClassScheduleConfigVisible: computed(() => perClassScheduleConfigVisible.value),
    setPerClassScheduleConfigVisible,
  }
})
